import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dateBlock", "dayLabel", "dateLabel", "timeLabel", "timeGrid"]

  connect() {
    this.doctorId = this.element.dataset.doctorId
    this.hospitalId = this.element.dataset.hospitalId
  }

  selectDate(event) {
    event.preventDefault()
    event.stopPropagation()

    const clickedBlock = event.currentTarget
    const selectedIndex = parseInt(clickedBlock.dataset.index, 10)

    this.dateBlockTargets.forEach((block) => {
      const idx = parseInt(block.dataset.index, 10)
      if (idx === selectedIndex) {
        block.className = "snap-start shrink-0 w-[70px] lg:w-auto rounded-xl py-2 px-1 text-center flex flex-col justify-center items-center transition-all duration-200 cursor-pointer select-none border border-primary bg-primary text-white shadow-xs"
        
        const dayLabel = this.dayLabelTargets.find(el => parseInt(el.dataset.index, 10) === idx)
        if (dayLabel) {
          dayLabel.className = "text-[10px] font-bold uppercase tracking-wider opacity-90 text-white"
        }
        const dateLabel = this.dateLabelTargets.find(el => parseInt(el.dataset.index, 10) === idx)
        if (dateLabel) {
          dateLabel.className = "text-xs font-black leading-tight mt-0.5 text-white"
        }
        const timeLabel = this.timeLabelTargets.find(el => parseInt(el.dataset.index, 10) === idx)
        if (timeLabel) {
          timeLabel.className = "text-[8px] font-bold mt-1 px-1 py-0.5 rounded-md bg-white/20 text-white"
        }
      } else {
        block.className = "snap-start shrink-0 w-[70px] lg:w-auto rounded-xl py-2 px-1 text-center flex flex-col justify-center items-center transition-all duration-200 cursor-pointer select-none border border-primary/15 dark:border-primary/30 bg-primary/5 dark:bg-primary/10 text-ink hover:bg-primary/10 hover:border-primary/30"
        
        const dayLabel = this.dayLabelTargets.find(el => parseInt(el.dataset.index, 10) === idx)
        if (dayLabel) {
          dayLabel.className = "text-[10px] font-bold uppercase tracking-wider text-primary/80 dark:text-primary-active"
        }
        const dateLabel = this.dateLabelTargets.find(el => parseInt(el.dataset.index, 10) === idx)
        if (dateLabel) {
          dateLabel.className = "text-xs font-black leading-tight mt-0.5 text-ink"
        }
        const timeLabel = this.timeLabelTargets.find(el => parseInt(el.dataset.index, 10) === idx)
        if (timeLabel) {
          timeLabel.className = "text-[8px] font-bold mt-1 px-1 py-0.5 rounded-md text-primary dark:text-primary-active bg-primary/10 dark:bg-primary/20"
        }
      }
    })

    this.timeGridTargets.forEach((grid) => {
      const idx = parseInt(grid.dataset.index, 10)
      if (idx === selectedIndex) {
        grid.classList.remove("hidden")
        grid.classList.add("grid")
      } else {
        grid.classList.remove("grid")
        grid.classList.add("hidden")
      }
    })
  }

  async selectTime(event) {
    event.preventDefault()
    event.stopPropagation()

    const button = event.currentTarget
    const date = button.dataset.date
    const dateFormatted = button.dataset.dateFormatted
    const time = button.dataset.time

    const modalEl = document.getElementById("appointmentModal")
    if (!modalEl) {
      console.error("Appointment modal not found")
      return
    }

    const modal = (window.Modal || (window.bootstrap && window.bootstrap.Modal)).getOrCreateInstance(modalEl)

    const triggerBtn = document.createElement("button")
    triggerBtn.setAttribute("data-doctor-id", this.doctorId)
    triggerBtn.setAttribute("data-hospital-id", this.hospitalId)
    triggerBtn.setAttribute("data-consult-date", date)
    triggerBtn.setAttribute("data-consult-time", time)
    triggerBtn.setAttribute("data-consult-date-formatted", dateFormatted)

    modal.show(triggerBtn)
  }
}
